import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'poster' | 'horizontal';
}

export default function MovieCard({ movie, variant = 'poster' }: MovieCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/article/${movie.id}`}
        className="flex gap-4 p-3 rounded-lg bg-background-100/60 hover:bg-background-300/30 transition-colors group cursor-pointer"
      >
        <div className="w-20 h-28 flex-shrink-0 rounded-md overflow-hidden">
          <img
            src={movie.poster}
            alt={movie.title}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex flex-col justify-between py-1 min-w-0">
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 group-hover:text-primary-400 transition-colors truncate">
              {movie.title}
            </h4>
            <p className="text-xs text-foreground-400 mt-1">{movie.year} · {movie.category} · {movie.duration}</p>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-xs font-semibold text-accent-500">{movie.rating}</span>
            <div className="flex items-center">
              <i className="ri-star-fill text-accent-500 text-xs" />
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${movie.id}`}
      className="group cursor-pointer block"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={movie.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent" />
        {movie.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-background-950 text-xs font-semibold">
            NEW
          </span>
        )}
        {movie.isHot && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
            热映
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex items-center gap-1 mb-1">
            <i className="ri-star-fill text-accent-500 text-xs" />
            <span className="text-xs font-semibold text-accent-400">{movie.rating}</span>
            <span className="text-xs text-foreground-400 ml-2">{movie.year}</span>
          </div>
          <h3 className="font-heading text-sm font-semibold text-foreground-50 truncate">
            {movie.title}
          </h3>
          <p className="text-xs text-foreground-400 mt-0.5 truncate">{movie.category} · {movie.duration}</p>
        </div>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5" />
          </div>
        </div>
      </div>
    </Link>
  );
}